import {StackItemInterface} from './interfaces';
import {generateRandomKey} from 'helpers/hash';

interface StackItemData {
    readonly minPlayersInPrimaryGroup: number;
    readonly maxPlayersInPrimaryGroup: number;
    readonly playerIdsInPrimaryGroup: Array<number>;
    readonly minPlayersInSecondaryGroup: number;
    readonly maxPlayersInSecondaryGroup: number;
    readonly playerIdsInSecondaryGroup: Array<number>;
    readonly useSecondaryGroup: boolean;
    readonly useStackInAllLineups: boolean;
    readonly minLineups: number;
}

export class StackItem implements StackItemInterface {
    readonly id: string;
    readonly data: StackItemData;

    constructor(data: StackItemData) {
        this.id = generateRandomKey();
        this.data = data;
    }
    getId(): string {
        return this.id;
    }
    getMinPlayersInPrimaryGroup(): number {
        return Number(this.data.minPlayersInPrimaryGroup);
    }
    getMaxPlayersInPrimaryGroup(): number {
        return Number(this.data.maxPlayersInPrimaryGroup);
    }
    getPlayerIdsInPrimaryGroup(): Array<number> {
        return [...this.data.playerIdsInPrimaryGroup];
    }
    getMinPlayersInSecondaryGroup(): number {
        return Number(this.data.minPlayersInSecondaryGroup);
    }
    getMaxPlayersInSecondaryGroup(): number {
        return Number(this.data.maxPlayersInSecondaryGroup);
    }
    getPlayerIdsInSecondaryGroup(): Array<number> {
        return [...this.data.playerIdsInSecondaryGroup];
    }
    isSecondaryGroupUsed(): boolean {
        return Boolean(this.data.useSecondaryGroup);
    }
    isStackUsedInAllLineups(): boolean {
        return Boolean(this.data.useStackInAllLineups);
    }
    getMinLineups(): number {
        return Number(this.data.minLineups);
    }
}
